import { CountUp } from 'countup.js';

const DELAY_IN_MILLIS_AFTER_IN_VIEW_BEFORE_COUNTING_UP = 300;
const ANIMATION_DURATION_IN_SECONDS = 4;

const animatedNumberElementsMap: { [key: string]: {
    hasAnimated: boolean;
    startValue: number;
    endValue: number;
} } = {};

initInViewportObserver();

function initInViewportObserver() {
    const observerOptions = {
        root: null, /* the browser viewport */
        threshold: 1, /* A value of 1.0 means that the threshold isn't considered passed until every pixel is visible */
        trackVisibility: false, /* if true, the browser will additionally check that the target is actually visible, but that is 'computationally intensive' */
    };

    const inViewportObserver = new IntersectionObserver(onNumberInViewport, observerOptions);

    document
        .querySelectorAll<HTMLElement>('.js-number-animated-when-in-view')
        .forEach((elem) => {
            initElement(elem);

            inViewportObserver.observe(elem);
        });
}

function initElement(element: HTMLElement) {
    const elementId = getElementId(element);

    if (!animatedNumberElementsMap[elementId]) {
        /* the element has not been initialized yet */

        const startValue = Number(getDataPropValue({ element, propName: 'startingValue' }));
        const amountToCountUp = Number(getDataPropValue({ element, propName: 'amountToCountUp' }));

        animatedNumberElementsMap[elementId] = {
            hasAnimated: false,
            startValue,
            endValue: startValue + amountToCountUp,
        };
    }
}

function onNumberInViewport(entries: IntersectionObserverEntry[]) {
    entries.forEach(entry => {
        const element = entry.target as HTMLElement;
        const elementId = getElementId(element);

        if (entry.isIntersecting && !animatedNumberElementsMap[elementId].hasAnimated) {
            /* the element is in view AND has not animated yet */

            const countUp = new CountUp(
                element,
                animatedNumberElementsMap[elementId].endValue,
                {
                    startVal: animatedNumberElementsMap[elementId].startValue,
                    duration: ANIMATION_DURATION_IN_SECONDS,
                    separator: '.',
                    decimal: ',',
                },
            );

            if (!countUp.error) {
                setTimeout(() => {
                    countUp.start();
                }, DELAY_IN_MILLIS_AFTER_IN_VIEW_BEFORE_COUNTING_UP);
            }

            animatedNumberElementsMap[elementId].hasAnimated = true;
        }
    });
}

function getElementId(element: HTMLElement): string {
    return getDataPropValue({
        element,
        propName: 'elementId',
    });
}

function getDataPropValue({
    element,
    propName,
}: {
    element: HTMLElement;
    propName: string;
}): string {
    return element.dataset[propName];
}
